<template>
  <admin-data-table
    item-type="note tag"
    :add-item="createNoteTag"
    :fetch-items="fetchNoteTags"
    :form-fields="['name']"
    :update-item="updateNoteTag"
    #default="{
      closeDialog,
      customPagination,
      dataTableRows,
      formData,
      isDialogOpen,
      isLoading,
      itemsPerPage,
      markAsActive,
      markAsInactive,
      openDialog,
      searchQueryChanged,
      submitDialogForm,
      toggleStatus,
      toggleStatusLabel,
      updateCurrentPage
    }"
  >
    <div class="u-p3">
      <el-data-table
        selectable
        :data="dataTableRows"
        :loading="isLoading"
        :actions="[
          {
            label: toggleStatusLabel,
            action: toggleStatus,
            type: 'single'
          },
          {
            label: 'Mark as Active',
            action: markAsActive,
            type: 'batch'
          },
          {
            label: 'Mark as Inactive',
            action: markAsInactive,
            type: 'batch'
          }
        ]"
        @search-query-changed="searchQueryChanged($event)"
        @search-query-submitted="updateCurrentPage()"
        :items-per-page="itemsPerPage"
        :custom-pagination="customPagination"
        @current-page-updated="updateCurrentPage($event)"
      >
        <div
          slot="above-table"
          class="l-flex-grid l-flex-grid--h-right u-mb2"
        >
          <el-button
            v-test-id="'create-note-tag-button'"
            size="small"
            type="primary"
            @click="openDialog"
          >
            Create Note Tag
          </el-button>
        </div>
        <el-data-table-column
          data-key="name"
          label="Title"
        />
        <el-data-table-column
          data-key="domain.name"
          label="Domain"
        />
        <el-data-table-column
          data-key="active"
          label="Status"
        >
          <template slot-scope="{active}">
            {{ active ? 'Active' : 'Inactive' }}
          </template>
        </el-data-table-column>
        <el-data-table-column
          data-key="date_added"
          label="Created on">
          <template slot-scope="{date_added}">
            <bc-date-display
              :date="date_added"
              format="DD MMM, YYYY">
            </bc-date-display>
          </template>
        </el-data-table-column>

      </el-data-table>
      <el-dialog
        title="Create a new note tag"
        width="35%"
        :visible.sync="isDialogOpen"
      >
        <el-form
          :model="formData"
          @submit.prevent.native="submitDialogForm"
        >
          <el-form-item
            label="Name"
            prop="name"
          >
            <el-input
              v-test-id="'note-tag-name'"
              name="name"
              autofocus
              autocomplete="off"
              v-validate="'noteTagFormat|required'"
              v-model="formData.name"
              data-element="name"
            />
          </el-form-item>
          <el-form-item
            label="Domain"
            prop="domain"
          >
            <el-select
              v-test-id="'note-tag-domain'"
              v-model="formData.domain"
              filterable
              default-first-option
              v-validate="'required'"
              data-vv-name="domain"
              data-vv-validate-on="change|blur"
              placeholder="Choose a domain"
            >
              <el-option
                v-for="item in domains"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="!item.active"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="closeDialog">
            Cancel
          </el-button>
          <el-button
            v-test-id="'dialog-submit-button'"
            type="primary"
            @click="submitDialogForm">
            Confirm
          </el-button>
        </span>
      </el-dialog>
    </div>
  </admin-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import notesActions from '#/notes/store/actionTypes'
import {AdminDataTable} from '#/notes/components/AdminDataTable'
import {cloneDeep} from 'lodash'

export default {
  name: 'NoteTagsDataTable',
  components: {
    AdminDataTable
  },
  inject: ['$validator'],
  computed: {
    ...mapState('notes', [
      'domains'
    ])
  },
  created () {
    this.fetchAllDomains()
  },
  methods: {
    ...mapActions({
      addNoteTag: notesActions.ADD_NOTE_TAG,
      fetchAllDomains: notesActions.FETCH_ALL_DOMAINS,
      fetchNoteTags: notesActions.FETCH_NOTE_TAGS,
      updateNoteTag: notesActions.UPDATE_NOTE_TAG
    }),
    serializeNoteTagRelationships (noteTag) {
      if (noteTag.domain) {
        noteTag.domain = {id: noteTag.domain}
      } else {
        delete noteTag.domain
      }
      return noteTag
    },
    createNoteTag (noteTag) {
      const serializedNoteTag = this.serializeNoteTagRelationships(cloneDeep(noteTag))
      return this.addNoteTag(serializedNoteTag)
    }
  }
}
</script>
